<p-dialog [visible]="show" styleClass="atlas-dialog-l" [closable]="false" [contentStyle]="{ height: '75vh' }">
  <ng-template pTemplate="header">
    <h4>{{ 'ecommerce.item.edit-header' | translate | titlecase }}</h4>
  </ng-template>
  <div [wl-busy-overlay]="isLoading">
    <wlx-tabs *ngIf="eCommerceItem" #ecomItemTabs>
      <wlx-tab [title]="'ecommerce.item.general' | translate | ucfirst">
        <ng-template wlLazyTabContent>
          <wl-ecom-item-edit-general [hidden]="!show" [eCommerceItem]="eCommerceItem"></wl-ecom-item-edit-general>
        </ng-template>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.images.title' | translate | ucfirst">
        <wl-ecom-item-edit-images
          [eCommerceItem]="eCommerceItem"
          (eComItemImagesChanged)="eComItemImagesChanged($event)"
        ></wl-ecom-item-edit-images>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.options.title' | translate | ucfirst">
        <wl-ecom-item-edit-option-types [eCommerceItem]="eCommerceItem"></wl-ecom-item-edit-option-types>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.shipping.title' | translate | ucfirst">
        <wl-ecom-item-edit-shipping
          [eCommerceItem]="eCommerceItem"
          (shippingItemTypeChanged)="shippingItemTypeChanged($event)"
        ></wl-ecom-item-edit-shipping>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.downloadable-web-content.title' | translate | ucfirst">
        <wl-ecom-item-edit-downloadable-web-content [eCommerceItem]="eCommerceItem"></wl-ecom-item-edit-downloadable-web-content>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.restrictions.title' | translate | ucfirst">
        <wl-ecom-item-edit-restrictions [eCommerceItem]="eCommerceItem"></wl-ecom-item-edit-restrictions>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.search-keywords' | translate | ucfirst">
        <wl-ecom-item-edit-search-keywords [eCommerceItem]="eCommerceItem"></wl-ecom-item-edit-search-keywords>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.custom-fields' | translate | ucfirst">
        <wl-ecom-item-edit-custom-fields
          [eCommerceItem]="eCommerceItem"
          (customFieldItemValueChanged)="customFieldItemValueChanged($event)"
        ></wl-ecom-item-edit-custom-fields>
      </wlx-tab>
      <wlx-tab [title]="'ecommerce.item.affiliation-codes.title' | translate | ucfirst">
        <wl-ecom-item-edit-affcodes [eCommerceItem]="eCommerceItem" (affCodeChanged)="affCodeChanged($event)"></wl-ecom-item-edit-affcodes>
      </wlx-tab>
    </wlx-tabs>
  </div>
  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!errorMessage">
      {{ errorMessage }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch">
      <button pButton type="button" [disabled]="isSaving" class="atlas-btn atlas-btn-secondary mr-10" (click)="setShow(false)">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button [disabled]="isSaveDisabled()" class="atlas-btn atlas-btn-primary" (click)="saveClicked()">
        <wl-busy [show]="isSaving"></wl-busy>
        {{ 'common.save' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
